import React from "react";
import { useQuery } from "@apollo/client";
import { HOME_FAQS_QUERY } from "../graphql/faqs";
import FaqAccordion from "./FaqAccordion";

type Faq = { id: string; question: string; answer: string; position: number };
type HomeFaqsData = { homeFaqs: Faq[] };

export default function HomeFaqSection() {
  const { data } = useQuery<HomeFaqsData>(HOME_FAQS_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  const faqs = data?.homeFaqs ?? [];
  if (!faqs.length) return null;

  return <FaqAccordion faqs={faqs} title="Frequently Asked Questions" />;
}
